import axios from 'axios';
import { Consequence } from '../../libs/utils';
import {
    SOURCE_PAYMENTS
} from '../../constants/endpoints';
import get from 'lodash/get';

export const CREATE_SOURCE_PAYMENT = 'CREATE_SOURCE_PAYMENT';
export const UPDATE_SOURCE_PAYMENT = 'UPDATE_SOURCE_PAYMENT';
export const DELETE_SOURCE_PAYMENT = 'DELETE_SOURCE_PAYMENT';
export const GET_SOURCE_PAYMENTS_ALL = 'GET_SOURCE_PAYMENTS_ALL';
export const GET_SOURCE_PAYMENT_BY_ID = 'GET_SOURCE_PAYMENT_BY_ID';
export const UPDATE_SOURCE_PAYMENT_STATUS = 'UPDATE_SOURCE_PAYMENT_STATUS';
export const GET_SOURCE_PAYMENTS_ACTIVES = 'GET_SOURCE_PAYMENTS_ACTIVES';
export const GET_PAYMENTS_TYPES = 'GET_PAYMENTS_TYPES';


export const createSourcePayment = (paymentData) => async (dispatch) => {
    try {
        const response = await axios.post(SOURCE_PAYMENTS, paymentData);
        return new Consequence({
            dispatch,
            payload: { data: get(response, 'data.data') },
            eventTypes: { success: CREATE_SOURCE_PAYMENT, error: 'ERROR' }
        });
    } catch (error) {
        console.error('Error creating source payment:', error);
        // Handle error appropriately
    }
};

export const getPaymentTypes = () => async (dispatch) => {
    try {
        const response = await axios.get(`${SOURCE_PAYMENTS}/catalog`);
        return new Consequence({
            dispatch,
            payload: { data: get(response, 'data.data') },
            eventTypes: { success: GET_PAYMENTS_TYPES, error: 'ERROR' }
        });
    } catch (error) {
        console.error('Error get payment types:', error);
        // Handle error appropriately
    }
};

export const updateSourcePayment = (id, paymentData) => async (dispatch) => {
    try {
        const response = await axios.put(`${SOURCE_PAYMENTS}/${id}`, paymentData);
        return new Consequence({
            dispatch,
            payload: { data: get(response, 'data.data') },
            eventTypes: { success: UPDATE_SOURCE_PAYMENT, error: 'ERROR' }
        });
    } catch (error) {
        console.error('Error updating source payment:', error);
        // Handle error appropriately
    }
};

export const updateSourcePaymentStatus = (id, paymentData) => async (dispatch) => {
    try {
        const response = await axios.put(`${SOURCE_PAYMENTS}/${id}`, paymentData);
        return new Consequence({
            dispatch,
            payload: { data: get(response, 'data.data') },
            eventTypes: { success: UPDATE_SOURCE_PAYMENT_STATUS, error: 'ERROR' }
        });
    } catch (error) {
        console.error('Error updating source payment:', error);
        // Handle error appropriately
    }
};

export const deleteSourcePayment = (id) => async (dispatch) => {
    try {
        await axios.delete(`${SOURCE_PAYMENTS}/${id}`);
        dispatch({
            type: DELETE_SOURCE_PAYMENT,
            payload: id,
        });
    } catch (error) {
        console.error('Error deleting source payment:', error);
    }
};

export const getSourcePaymentsAll = () => async (dispatch) => {
    try {
        const response = await axios.get(SOURCE_PAYMENTS);
        dispatch({
            type: GET_SOURCE_PAYMENTS_ALL,
            payload: response.data.data,
        });
    } catch (error) {
        console.error('Error fetching all source payments:', error);
    }
};

export const getSourcePaymentsActives = () => async (dispatch) => {
    try {
        const response = await axios.get(`${SOURCE_PAYMENTS}/actives`);
        dispatch({
            type: GET_SOURCE_PAYMENTS_ACTIVES,
            payload: response.data.data,
        });
    } catch (error) {
        console.error('Error fetching all source payments:', error);
    }
};

export const getSourcePaymentById = (id) => async (dispatch) => {
    try {
        const response = await axios.get(`${SOURCE_PAYMENTS}/${id}`);
        dispatch({
            type: GET_SOURCE_PAYMENT_BY_ID,
            payload: response.data,
        });
    } catch (error) {
        console.error('Error fetching source payment by ID:', error);
        // Handle error appropriately
    }
};



// WEBPACK FOOTER //
// ./src/redux/actions/sourcePaymentsActions.js